export default __webpack_public_path__ + "static/media/up-arrow.b2a8e20b.svg";